import React from 'react'

const Interests = () => {
  return (
    <section>
                <div className="w3-card w3-round w3-white w3-hide-small">
          <div className="w3-container">
            <p>Interests</p>
            <p>
              <span className="w3-tag w3-small w3-theme-d5">News</span>
              <span className="w3-tag w3-small w3-theme-d4">W3Schools</span>
              <span className="w3-tag w3-small w3-theme-d3">Labels</span>
              <span className="w3-tag w3-small w3-theme-d2">Games</span>
              <span className="w3-tag w3-small w3-theme-d1">Friends</span>
              <span className="w3-tag w3-small w3-theme">Games</span>
              <span className="w3-tag w3-small w3-theme-l1">Friends</span>
              <span className="w3-tag w3-small w3-theme-l2">Food</span>
              <span className="w3-tag w3-small w3-theme-l3">Design</span>
              <span className="w3-tag w3-small w3-theme-l4">Art</span>
              <span className="w3-tag w3-small w3-theme-l5">Photos</span>
            </p>
          </div>
        </div>
    </section>
  )
}

export default Interests